import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from 'styleguide';

import IconPhoto from 'icons/Photo';
import IconVideo from 'icons/Video';
import { ReactComponent as CheckIcon } from 'icons/Check.svg';

import Wrapper from './Wrapper';
import InfoFile from './InfoFile';
import Info from './Info';
import CheckWrapper from './CheckWrapper';
import Line from './Line';

const MaterialTypeTabs = props => (
  <div style={{ borderBottom: `1px solid ${COLORS.line}`, padding: '8px 16px 24px' }}>
    <Wrapper>
      <InfoFile
        name="image"
        onClick={props.onFilterChange}
        active={props.filter === 'image'}
        style={{ marginRight: '50px' }}
      >
        <IconPhoto />

        <Info>
          <CheckWrapper><CheckIcon /></CheckWrapper>

          <span>{props.acceptedImageCount || 0}</span>

          <Line />

          <span>{props.imagesCount || 0}</span>
        </Info>
      </InfoFile>

      <InfoFile
        name="video"
        onClick={props.onFilterChange}
        active={props.filter === 'video'}
      >
        <IconVideo />

        <Info>
          <CheckWrapper><CheckIcon /></CheckWrapper>

          <span>{props.acceptedVideoCount || 0}</span>

          <Line />

          <span>{props.videosCount || 0}</span>
        </Info>
      </InfoFile>
    </Wrapper>
  </div>
);

MaterialTypeTabs.propTypes = {
  imagesCount: PropTypes.number,
  videosCount: PropTypes.number,
  acceptedImageCount: PropTypes.number,
  acceptedVideoCount: PropTypes.number,
  onFilterChange: PropTypes.func,
  filter: PropTypes.oneOf(['image', 'video']),
};

MaterialTypeTabs.defaultProps = {
  imagesCount: 0,
  videosCount: 0,
  acceptedImageCount: 0,
  acceptedVideoCount: 0,
  filter: 'image',
  onFilterChange: () => {},
};

export default MaterialTypeTabs;
